export default "__VITE_ASSET__7v_v3LSu__"